import Vue from 'vue';
import "../plugins/config.js";
import "../plugins/service/index.js";

Vue.prototype.$regras = new Vue({
    methods: {
        add(item, apre){
            const session = this.$axios.getLocal('session')
            const limite = this.$config.regrasDoNegocio.limitCompraDia

            // PARCEIRO e GUIA nao tem o limite fixo por item, so a capacidade do horario (validada no back)
            const tipo = session && session.data ? String(session.data.dscpessoa_tipo || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase() : ''
            const semLimite = ['PARCEIRO', 'GUIA'].includes(tipo)

            if(!semLimite && item.qtd > limite){
                this.$axios.modalBar('', `Limite de compra atingido: máximo de ${limite} unidades por item`)
                return false
            }

            return true
        }
    }
})